const rolePowerMixin = {
  data () {
    return {
      countRequest: 0,
      // 改变了的角色权限类型
      changedType: [],
      // 当前选中的角色权限
      currentSelectPower: {
        menu: [],
        process: [],
        app: [],
        other: [],
        homePage: [],
        system: []
      },
      rolePowerType: '',
      loadingPowerLists: true,
      // 角色权限列表, 内部按类型区分
      powersListObj: {
        menu: [],
        process: [],
        app: [],
        other: [],
        system: []
      },
      checkedList: {},
      menuList: [],
      home: '',
      homePagePower: false
    }
  },
  methods: {
    // 获取所有菜单和权限数据
    getAllMenusAndPowers () {
      let allMenus = [
        {name: '菜单权限', type: 'menu'},
        {name: '流程权限', type: 'process'},
        {name: 'APP权限', type: 'APP_Other'},
        {name: '企业微信权限', type: 'qywx'},
        {name: '其他权限', type: 'other'}
      ]
      if (this.isAdmin) {
        allMenus.push({name: '系统权限', type: 'system'})
      }
      let getAllMenusPromise = allMenus.map(e => {
        return this.getPowersList(e.type)
      })
      return Promise.all(getAllMenusPromise).then(() => {
        this.$nextTick(() => {
          if (this.countRequest === 0) {
            this.loadingPowerLists = false
          }
        })
      })
    },
    // 获取菜单
    getPowersList (type) {
      this.loadingPowerLists = true
      // 用户快速切换的时候统计发送的请求, 所有请求完成之后再展示, 否则会由于关闭tree的严格不相关选项导致无权限的也被选中
      this.countRequest += 1
      return new Promise(async (resolve, reject) => {
        let menuType = type || ''
        if (type === 'APP_Other') {
          menuType = 'app'
        }
        if (type === 'other') {
          await this.getMenuList()
          await this.getUserPower(this.selectPowerId, 'homePage')
          this.countRequest -= 1
          return resolve()
        } else {
          this.$axios.get(`/auth-api/roles/getRoleMenuList?menuType=${menuType}`).then(async res => {
            if (this.rolePowerType === 'peopleManagement') {
              // 给所有项加上禁用
              res.data = this.disabledNode(res.data)
            }
            // 只有当前选择群组的数据返回来了才赋值
            // 获取完权限菜单列表之后获取所有权限
            if (this.selectPowerId) {
              await this.getUserPower(this.selectPowerId, type)
              // 如果是APP,给外面嵌套一层APP层,保存的时候只传他的children id是手动写死的 ; 同时给二级菜单(原来的一级菜单)全部设置为这个id
              if (menuType === 'app') {
                res.data && res.data.forEach(e => {
                  if (!e.parentId) {
                    e.parentId = '1_43F47C-7940-0015-9F77-9965999EB4_G'
                  }
                })
                res.data = [{
                  id: '1_43F47C-7940-0015-9F77-9965999EB4_G',
                  name: 'APP',
                  parentId: '',
                  checked: false,
                  children: [...res.data],
                  disabled: this.rolePowerType === 'peopleManagement'
                }]
              }
              let data = this.countChildrenChecked(res.data, type)
              this.$set(this.powersListObj, menuType === 'app' ? type : menuType, data)
              this.countRequest -= 1
              resolve()
            }
          }).catch(() => {
            this.countRequest -= 1
          })
        }
      })
    },
    // 获取主页菜单
    getMenuList () {
      return this.$axios.get('/auth-api/menus/getAllMenu').then(res => {
        this.menuList = []
        res.data.forEach(m => {
          if (m.link) {
            this.menuList.push({id: m.id, name: m.name, link: m.link})
          }
        })
      })
    },
    // 根据id获取用户的权限
    getUserPower (id, type) {
      if (type === 'APP_Other') {
        type = 'app'
      }
      let url = `/auth-api/roles/getRoleMenuByRoleIdAndType?roleId=${id}&menuType=${type}`
      if (this.rolePowerType === 'peopleManagement') {
        url = `/auth-api/roles/getRoleMenuByUserIdAndMenuType?userId=${id}&menuType=${type}`
      }
      return this.$axios
        .get(url)
        .then(res => {
          // 只有当前选择群组的数据返回来了才赋值
          if (res.data.roleId === this.selectPowerId || this.rolePowerType === 'peopleManagement') {
            if (type === 'app') {
              this.checkedList['APP_Other'] = res.data[type] || []
              // 如果app中有被选中项,则默认让最外层手动嵌套的app层被选中
              if (res.data[type] && res.data[type].length !== 0) {
                this.checkedList['APP_Other'].push('1_43F47C-7940-0015-9F77-9965999EB4_G')
              }
            } else if (type === 'homePage') {
              this.home = res.data.homePage && res.data.homePage[0]
              this.homePagePower = !!this.home
            } else {
              this.checkedList[type] = res.data[type] || []
            }
            return Promise.resolve()
          }
        })
    },
    // 其他权限 - 主页的保存
    setHomePagePower (val, type) {
      // 如果勾选了 或者是 切换权限开启或关闭
      if (this.homePagePower || type === 'checked') {
        !this.changedType.includes('homePage') && this.changedType.push('homePage')
        this.currentSelectPower['homePage'] = type === 'checked' && val === false ? [] : (this.home && this.home.split()) || []
      }
    },
    // 统计当前群组下被选中的数量
    countChildrenChecked (data = [], type) {
      data.forEach(parentObj => {
        if (parentObj.children && parentObj.children.length > 0) {
          let allMenuIdsArray = this.getAllMenuIds(parentObj)
          this.$set(parentObj, 'totalMenus', allMenuIdsArray.length)
          this.$set(parentObj, 'checkedMenus', this.$_.intersection(allMenuIdsArray, this.checkedList[type]).length)
          if (parentObj.totalMenus > 0 && parentObj.checkedMenus > 0) {
            if (parentObj.totalMenus > parentObj.checkedMenus) {
              this.$set(parentObj, 'halfCheckedStatus', true)
            } else {
              this.$set(parentObj, 'halfCheckedStatus', false)
            }
          } else if (parentObj.link && parentObj.totalMenus > parentObj.checkedMenus && this.checkedList[type] !== undefined && this.checkedList[type].includes(parentObj.id)) {
            // 如果是报表 且 没有被全部选中 且 自身是被选中的 则也展示半选中图标
            // todo: 这里使用的是含链接来判断是否报表 不够严谨, 56期新增了 functionType: '2' 来判断, 还未上线, 上线后可更改
            this.$set(parentObj, 'halfCheckedStatus', true)
          } else {
            this.$set(parentObj, 'halfCheckedStatus', false)
          }
          this.countChildrenChecked(parentObj.children, type)
        }
      })
      return data
    },
    // 获取当前菜单下的所有菜单id
    getAllMenuIds (parentObj, allMenuIdsArray = []) {
      parentObj.children.forEach(c => {
        if (c && c.id) {
          allMenuIdsArray.push(c.id)
        }
        // 过滤掉所有页面下的按钮
        if (!c.link && c.children && c.children.length > 0) {
          this.getAllMenuIds(c, allMenuIdsArray)
        }
      })
      return allMenuIdsArray
    },
    // 禁用所有节点
    disabledNode (nodeArray) {
      nodeArray.forEach(node => {
        if (!('disabled' in node)) {
          node.disabled = true
        }
        if (node.children && node.children.length > 0) {
          this.disabledNode(node.children)
        }
      })
      return nodeArray
    },
    // 重置当前群组信息
    resetRoleList () {
      this.powersListObj = {
        menu: [],
        process: [],
        app: [],
        other: [],
        system: []
      }
      this.checkedList = {}
      this.$refs.powerListTree.currentShowTree = ['menu']
      this.$refs.powerListTree.$refs.menu[0].setCheckedKeys([])
    }
  }
}

export { rolePowerMixin }



// WEBPACK FOOTER //
// ./src/components/system/users/usersMixin.js